import { render, staticRenderFns } from "./LegalPersonValidationDocs.vue?vue&type=template&id=00b2b4d5&scoped=true"
import script from "./LegalPersonValidationDocs.vue?vue&type=script&lang=js"
export * from "./LegalPersonValidationDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2b4d5",
  null
  
)

export default component.exports